export default __webpack_public_path__ + "static/media/1_0122.49030dbe.webp";